import { useContext }               from 'react';
import { ModalProps, SidebarProps } from 'semantic-ui-react';

import { DynamicComponentsContext, SystemUtilContext, ThemeContext, ThemeContextType } from '../views/contexts';

import { ToastHookActions }            from './useToasts';
import { TogglableContentHookActions } from './useTogglableContentReducer';
import { UseLoggingHookActions }       from './useLogging';


interface UseSystemHookComponents {
    toastActions: ToastHookActions,
    modalActions: TogglableContentHookActions<ModalProps>
    sidebarActions: TogglableContentHookActions<SidebarProps>
    systemLog: UseLoggingHookActions,
    systemTheme: ThemeContextType,
}

type UseSystemHook = () => UseSystemHookComponents

export const useSystemToasts = (): UseSystemHookComponents['toastActions'] => {

    let { toasts: [ , toastActions ] } = useContext( DynamicComponentsContext );

    return toastActions;
};

export const useSystemModals = (): UseSystemHookComponents['modalActions'] => {

    let { modal: [ , modalActions ] } = useContext( DynamicComponentsContext );

    return modalActions;
};

export const useSystemSidebar = (): UseSystemHookComponents['sidebarActions'] => {

    let { sidebar: [ , sidebarActions ] } = useContext( DynamicComponentsContext );

    return sidebarActions;
};

export const useSystemLogging = (): UseSystemHookComponents['systemLog'] => {

    let { logging } = useContext( SystemUtilContext );

    return logging;
};

export const useSystemTheme = (): UseSystemHookComponents['systemTheme'] => {

    let theme = useContext( ThemeContext );

    return theme;
};

export const useSystem: UseSystemHook = () => {

    let toastActions   = useSystemToasts(),
        modalActions   = useSystemModals(),
        systemLog      = useSystemLogging(),
        systemTheme    = useSystemTheme(),
        sidebarActions = useSystemSidebar();

    return {
        toastActions,
        modalActions,
        sidebarActions,
        systemLog,
        systemTheme,
    };
};
